export default __webpack_public_path__ + "static/media/Incontro letterario 3.2d39d186.jpg";